// extracted by mini-css-extract-plugin
export var answerText = "FAQ-module--answer-text--25552";
export var container = "FAQ-module--container--aaa05";
export var header = "FAQ-module--header--41a07";
export var heading = "FAQ-module--heading--c2b88";